import React from "react";
import MainSubHeading from "../../Sub-Heading/MainSubHeading";
import { Container, Row, Col } from "react-bootstrap";
import intCallForPapersIntConf from "../../../assets/blogs/internal-blogs/int-call-for-papers-international-conference.webp";
export default function callForPapersInternationalConference() {
  const subheadingData = "Proposals"; // You should replace this with your actual subheading data
  return (
    <>
      <Container>
        <MainSubHeading subheading={subheadingData} />
        <div className="mt-4">
          <h1 className="text-center">
            Call for Papers | International Conference on Digital Demos: Data, Power and Politics in the EU and India
          </h1>
        </div>
        <Row>
          <Col className="text-center mb-4">
            <img src={intCallForPapersIntConf} alt="" className="img-fluid" style={{ width: "60%" }} />
          </Col>
        </Row>
        <p>
          As data increasingly shapes governance, economies, and democratic systems, critical questions around power, 
          ownership, accountability, and regulation are becoming more important than ever.

        </p>
        <p>
          We invite scholars and researchers to submit papers for the International Conference on “Digital Demos: Data, Power and Politics in the EU and India”, 
          organised under the Jean Monnet Module on “Digital Democracy and Data Governance in the European Union” 
          by the Human Sciences Research Centre, IIIT Hyderabad, in collaboration with IHub Data, IIIT Hyderabad 
          and the Department of Political Science, University of Hyderabad, with co-funding from the European Union.
        </p>
        <p>
          📍 IIIT Hyderabad <br/>
          📅 September 9–10, 2026
        </p>
        <p>
          We welcome interdisciplinary research on data governance, digital public infrastructure, AI governance, data sovereignty, 
          accountability, digital rights, and the future of data ecosystems.
        </p>

        <p>
            🗓️ Abstract Submission Deadline: June 30, 2026 (5 PM IST) <br />
            📩 Submit your abstract: <a href="https://forms.office.com/pages/responsepage.aspx?id=vDsaA3zPK06W7IZ1VVQKHGLM80Is4o1Hnf7OTqVDVG5UNlQyM0JNSVpOMk9ZUk0ySjBPUzNaMldSMS4u&route=shorturl" target="_blank" rel="noopener noreferrer">
              Please fill out this form
        </a>
        </p>
        
      </Container>
    </>
  );
}